export default __webpack_public_path__ + "static/media/download-sbc.d0be6385.webp";